(function () {
    function clearAnimation(sectionElement) {
        if (sectionElement._filadelfiaSecondSectionTrigger) {
            sectionElement._filadelfiaSecondSectionTrigger.kill();
            sectionElement._filadelfiaSecondSectionTrigger = null;
        }

        if (sectionElement._filadelfiaSecondSectionTween) {
            sectionElement._filadelfiaSecondSectionTween.kill();
            sectionElement._filadelfiaSecondSectionTween = null;
        }

        if (sectionElement._filadelfiaSecondSectionIntro) {
            if (sectionElement._filadelfiaSecondSectionIntro.scrollTrigger) {
                sectionElement._filadelfiaSecondSectionIntro.scrollTrigger.kill();
            }

            sectionElement._filadelfiaSecondSectionIntro.kill();
            sectionElement._filadelfiaSecondSectionIntro = null;
        }

    }

    function getScrollDistance(track, viewport) {
        return Math.max(track.scrollWidth - viewport.clientWidth, 0);
    }

    function getScrollDuration(track, viewport) {
        var distance = getScrollDistance(track, viewport);
        var mobileMultiplier = window.innerWidth < 750 ? 1.85 : 1;

        return Math.max(distance * mobileMultiplier, viewport.clientWidth * 0.9);
    }

    function splitLineChars(lineElement) {
        if (!lineElement) {
            return [];
        }

        var originalText = lineElement.dataset.originalText || lineElement.textContent;
        lineElement.dataset.originalText = originalText;
        lineElement.textContent = '';
        lineElement.setAttribute('aria-hidden', 'true');

        originalText.split('').forEach(function (character) {
            var characterElement = document.createElement('span');
            characterElement.className = 'filadelfia-second-section__char';

            if (character === ' ') {
                characterElement.className += ' filadelfia-second-section__char--space';
                characterElement.innerHTML = '&nbsp;';
            } else {
                characterElement.textContent = character;
            }

            lineElement.appendChild(characterElement);
        });

        return Array.prototype.slice.call(lineElement.querySelectorAll('.filadelfia-second-section__char'));
    }

    function initTextReveal(sectionElement, reduceMotion) {
        if (sectionElement.dataset.textRevealInitialized === 'true') {
            return;
        }

        sectionElement.dataset.textRevealInitialized = 'true';

        var firstLine = sectionElement.querySelector('[data-second-section-first-line]');
        var tagElement = sectionElement.querySelector('[data-second-section-tag]');
        var secondLine = sectionElement.querySelector('[data-second-section-second-line]');

        if (!firstLine || !tagElement || !secondLine) {
            return;
        }

        var firstChars = splitLineChars(firstLine);
        var secondChars = splitLineChars(secondLine);
        var allChars = firstChars.concat(secondChars);

        function runIfAlreadyPast(startRatio, callback) {
            var sectionTop = sectionElement.getBoundingClientRect().top;

            if (sectionTop <= window.innerHeight * startRatio) {
                callback();
            }
        }

        function revealCharsOnce(chars, flagName) {
            if (sectionElement.dataset[flagName] === 'true') {
                return;
            }

            sectionElement.dataset[flagName] = 'true';

            window.gsap.to(chars, {
                autoAlpha: 1,
                yPercent: 0,
                stagger: 0.02,
                ease: 'power1.inOut',
                duration: 0.62,
                overwrite: true
            });
        }

        function revealTagOnce() {
            if (sectionElement.dataset.tagRevealDone === 'true') {
                return;
            }

            sectionElement.dataset.tagRevealDone = 'true';

            window.gsap.to(tagElement, {
                duration: 1,
                clipPath: 'polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)',
                ease: 'power1.inOut',
                overwrite: true
            });
        }

        if (reduceMotion) {
            window.gsap.set(allChars, { autoAlpha: 1, yPercent: 0 });
            window.gsap.set(tagElement, {
                clipPath: 'polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)'
            });
            sectionElement.dataset.textRevealReady = 'true';
            return;
        }

        window.gsap.set(allChars, { autoAlpha: 0, yPercent: 200 });
        window.gsap.set(tagElement, {
            clipPath: 'polygon(50% 0%, 50% 0%, 50% 100%, 50% 100%)'
        });
        sectionElement.dataset.textRevealReady = 'true';

        sectionElement._filadelfiaSecondSectionTextTriggers = [
            window.ScrollTrigger.create({
                trigger: sectionElement,
                start: 'top 30%',
                once: true,
                onEnter: function () {
                    revealCharsOnce(firstChars, 'firstTextRevealDone');
                }
            }),
            window.ScrollTrigger.create({
                trigger: sectionElement,
                start: 'top 10%',
                once: true,
                onEnter: revealTagOnce
            }),
            window.ScrollTrigger.create({
                trigger: sectionElement,
                start: 'top 1%',
                once: true,
                onEnter: function () {
                    revealCharsOnce(secondChars, 'secondTextRevealDone');
                }
            })
        ];

        runIfAlreadyPast(0.3, function () {
            revealCharsOnce(firstChars, 'firstTextRevealDone');
        });
        runIfAlreadyPast(0.1, revealTagOnce);
        runIfAlreadyPast(0.01, function () {
            revealCharsOnce(secondChars, 'secondTextRevealDone');
        });
    }

    function initSecondSection(sectionElement) {
        if (!sectionElement) {
            return;
        }

        var viewport = sectionElement.querySelector('[data-second-section-viewport]');
        var track = sectionElement.querySelector('[data-second-section-track]');
        var items = sectionElement.querySelectorAll('[data-second-section-item]');

        if (!viewport || !track || !items.length) {
            return;
        }

        if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') {
            return;
        }

        window.gsap.registerPlugin(window.ScrollTrigger);
        clearAnimation(sectionElement);
        window.gsap.set(track, { x: 0 });
        window.gsap.set(items, { autoAlpha: 1, y: 0 });

        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var overflowDistance = getScrollDistance(track, viewport);

        initTextReveal(sectionElement, reduceMotion);

        if (!reduceMotion) {
            sectionElement._filadelfiaSecondSectionIntro = window.gsap.fromTo(items, {
                y: 18,
                autoAlpha: 0
            }, {
                y: 0,
                autoAlpha: 1,
                duration: 0.75,
                ease: 'power2.out',
                stagger: 0.08,
                scrollTrigger: {
                    trigger: sectionElement,
                    start: 'top 82%',
                    once: true
                }
            });
        }

        if (reduceMotion || overflowDistance <= 0) {
            return;
        }

        sectionElement._filadelfiaSecondSectionTween = window.gsap.to(track, {
            x: function () {
                return -getScrollDistance(track, viewport);
            },
            ease: 'none',
            scrollTrigger: {
                trigger: sectionElement,
                start: 'top top',
                end: function () {
                    return '+=' + getScrollDuration(track, viewport);
                },
                scrub: 1,
                pin: true,
                anticipatePin: 1,
                invalidateOnRefresh: true
            }
        });

        sectionElement._filadelfiaSecondSectionTrigger = sectionElement._filadelfiaSecondSectionTween.scrollTrigger;

        window.ScrollTrigger.refresh();
    }

    window.filadelfiaSecondSection = {
        init: initSecondSection
    };

    window.addEventListener('resize', function () {
        window.clearTimeout(window.filadelfiaSecondSectionResizeTimer);
        window.filadelfiaSecondSectionResizeTimer = window.setTimeout(function () {
            document.querySelectorAll('[data-second-section]').forEach(initSecondSection);
            if (window.ScrollTrigger) {
                window.ScrollTrigger.refresh();
            }
        }, 180);
    });
})();
